import { ButtonIcon, Dropdown } from '@cubeyou-team/hx-react-components';
import React, { FC, useState } from 'react';

import { ProductsDropdownContent } from './components';

interface ProductsDropdownProps {
  products: any[];
  dropdownPosition?: 'left' | 'right';
}

export const ProductsDropdown: FC<ProductsDropdownProps> = ({
  products,
  dropdownPosition,
}) => {
  const [isDropdownOpen, SetIsDropdownOpen] = useState(false);

  return (
    <Dropdown
      position={dropdownPosition}
      setLargeMinWidth
      isOpen={isDropdownOpen}
      content={<ProductsDropdownContent products={products} />}
      onClickOutside={() => SetIsDropdownOpen(false)}
    >
      <ButtonIcon
        icon="menu"
        variant="light"
        size="medium"
        onClick={() => SetIsDropdownOpen(!isDropdownOpen)}
      />
    </Dropdown>
  );
};
